import { render, staticRenderFns } from "./CrosswordPublisher.vue?vue&type=template&id=48889f22&scoped=true"
import script from "./CrosswordPublisher.vue?vue&type=script&lang=js"
export * from "./CrosswordPublisher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48889f22",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LoadingSpinner: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/common/LoadingSpinner.vue').default,CrosswordClueList: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/crossword/CrosswordClueList.vue').default,CrosswordPublisherGridList: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/crossword/CrosswordPublisherGridList.vue').default,CrosswordPublisherCopy: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/crossword/CrosswordPublisherCopy.vue').default,Advertisement: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/Advertisement/Advertisement.vue').default,TheSidebar: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/template/TheSidebar.vue').default,ScrollTriggeredModal: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/crossword/ScrollTriggeredModal.vue').default})
